<template>
    <svg
        id="File_Word"
        data-name="File Word"
        xmlns="http://www.w3.org/2000/svg"
        width="16.884"
        height="20.61"
        viewBox="0 0 16.884 20.61"
    >
        <path
            id="Pfad_372"
            data-name="Pfad 372"
            d="M15.5,20.61H1.38A1.333,1.333,0,0,1,0,19.333V1.278A1.334,1.334,0,0,1,1.38,0H9.765a.843.843,0,0,1,.588.234l6.309,6.152a.721.721,0,0,1,.223.516V19.333A1.334,1.334,0,0,1,15.5,20.61M1.622,19.11H15.263V7.2L9.417,1.5h-7.8Z"
            fill="#2b579a"
        />
        <path
            id="Pfad_373"
            data-name="Pfad 373"
            d="M15.415,7.832H9.625a1.463,1.463,0,0,1-1.51-1.407V.75H9.737V6.332h5.679Z"
            transform="translate(0.657 0)"
            fill="#2b579a"
        />
        <path
            id="Pfad_374"
            data-name="Pfad 374"
            d="M3.485,9.933H4.662l1.4,5.1,1.519-5.1H8.828L10.239,15,11.65,9.933h1.188L10.833,16.19H9.578L8.156,11.454,6.648,16.19,5.4,16.2Z"
            transform="translate(0.282 0)"
            fill="#2b579a"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "FileWordIcon",
    props: {},
});
</script>
